const settings = {
    mapArgs: {
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: true,
        clickableIcons: false,
        zoom: 4,
        center: {
            lat: 41.2954735,
            lng: -95.99383390000001,
        },
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    {
                        'visibility': 'off',
                        'line-height': '20px',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#1c2263',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'all',
                stylers: [
                    {
                        color: '#efe5e5',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off',
                    },
                    {
                        weight: '1.09',
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'all',
                stylers: [
                    {
                        saturation: -100,
                    },
                    {
                        lightness: 45,
                    },
                    {
                        visibility: 'on',
                    },
                    {
                        hue: '#00ddff',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'simplified',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'all',
                stylers: [
                    {
                        color: '#ceddf0',
                    },
                    {
                        visibility: 'on',
                    },
                ],
            },
        ],
    },
};

export default class Map {
    constructor(container) {
        if (!container) {
            return;
        }

        this.map = new google.maps.Map(container, settings.mapArgs);
        this.markers = [];
        this.previousInfoWindow = null;
    }

    deleteMarkers() {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        this.markers = [];
    }

    addMarker(lat, lng, html, surgeonID) {
        const markerCoordinates = {};
        markerCoordinates.lat = parseFloat(lat);
        markerCoordinates.lng = parseFloat(lng);

        const iconSize = new google.maps.Size(24, 32);

        const marker = new google.maps.Marker({
            map: this.map,
            position: markerCoordinates,
            icon: {
                url: '/wp-content/themes/resensation/assets/img/surgeon-locator/pin-pink-solid.svg',
                size: iconSize,
                scaledSize: iconSize,
            },
            title: `Map location pin`,
        });

        marker.set('html', html);
        marker.set('id', surgeonID);
        this.markers.push(marker);

        marker.addListener('click', (event) => {
            this.map.panTo(marker.getPosition());

            const locationHTML = marker.get('html');

            const infowindow = new google.maps.InfoWindow({
                content: locationHTML,
                minWidth: 300,
            });

            infowindow.open(this.map, marker);

            if (this.previousInfoWindow) {
                this.previousInfoWindow.close();
            }

            this.previousInfoWindow = infowindow;
        });
    }

    recenter() {
        if (this.markers.length) {
            const bounds = new google.maps.LatLngBounds();

            for (let i = 0; i < this.markers.length; i++) {
                bounds.extend({
                    lat: this.markers[i].position.lat(),
                    lng: this.markers[i].position.lng(),
                });
            }

            if (this.markers.length == 1) {
                this.map.setCenter(bounds.getCenter());
                this.map.setZoom(16);
            } else {
                this.map.fitBounds(bounds);

                // Limit zoom amount - smaller than 3 is too far out,
                // while greater than 16 is too far in
                const zoomLevel = this.map.getZoom();
                if (zoomLevel < 3) {
                    this.map.setZoom(3);
                } else if (zoomLevel > 16) {
                    this.map.setZoom(16);
                }
            }
        } else {
            const lat = getUrlVars()['lat'];
            const lng = getUrlVars()['lng'];

            this.map.setCenter({
                lat: parseFloat(lat),
                lng: parseFloat(lng),
            });

            this.map.setZoom(4);
        }
    }

    highlightMarkersForSurgeonId(highlight, surgeonID) {
        // Find markers that reference this ID
        for (const marker of this.markers) {
            const surgeonIDs = JSON.parse(marker.get('id'));
            if (!surgeonIDs.includes(surgeonID)) {
                continue;
            }

            const iconSize = highlight ?
                new google.maps.Size(30, 40) :
                new google.maps.Size(24, 32);
            const color = highlight ? 'purple-solid' : 'pink-solid';
            const zIndex = highlight ? 100 : 1;

            marker.setIcon({
                url: `/wp-content/themes/resensation/assets/img/surgeon-locator/pin-${color}.svg`,
                size: iconSize,
                scaledSize: iconSize,
            });
            marker.setZIndex(zIndex);
        }
    }
}
